module.exports = __webpack_public_path__ + "420e29f170105e6131e97f822f9de03e.svg";